import { mergeConfig } from '../../Core/Helpers/configHelpers';
import qestIds from '../../QestIds';
import getMeasuredUsingConfig from '../measuredUsingConfig';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.SamplingDetails.MassPerIncrement`]: { uom: 'kg', format: { nearest: 0.1 } },
      [`${prefix}.SamplingDetails.NominalAggregateSize`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.SamplingDetails.MinimumSampleMassRequired`]: { uom: 'kg', format: { nearest: 1 } },

      [`${prefix}.SamplingDetails.NoBag`]: { format: { nearest: 1 } },
      [`${prefix}.Results.SampleMass`]: { uom: 'kg', format: { nearest: 0.1 } },
      [`${prefix}.SamplingDetails.Balance`]: {
        defaultReadability: 0.005,
        defaultUom: 'kg',
      },
    },
    getMeasuredUsingConfig(prefix),
    getLabelConfig(prefix)
  );

export default {
  [qestIds.samplingCertificate.BS_EN_932_1_Rev1997]: getConfig,
  [qestIds.samplingCertificate.BS_5930_Rev2015]: getConfig,
};
